<template>
    <q-card class="bg-grey-1">
        <q-card-media :class="trail.is_blocked ? 'disable-image' : ''" @click.native="goToTrail()">
            <img :src="trail.image_small" v-if="trail.image_small">
            <img :src="getPlaceholder" v-if="!trail.image_small">
        </q-card-media>

        <q-card-main class="relative-position" @click.native="goToTrail()">
            <div class="line-card bg-primary absolute-top"></div>

            <div class="row q-my-sm">
                <div class="col-10">
                    <div class="row">
                        <div class="col-12 q-title text-weight-medium" :class="trail.is_blocked ? 'text-faded' : 'text-primary'">
                            {{ trail.title }}
                        </div>

                        <div class="col-12 q-mb-md">
                            <q-rating color="amber" slot="subtitle" icon="fas fa-star" v-model="trail.stars" :max="5" readonly />
                        </div>
                    </div>
                </div>

                <div class="col-2 text-center">
                    <vc-donut :sections="sections" :size="100" unit="%">
                        <h6 v-if="trail.user_trail_progress < 100 && trail.trail_user_result_status != 2" :class="trail.is_blocked ? 'text-faded' : 'text-primary'">
                            {{ getPercentage(trail.user_trail_progress) }}%
                        </h6>

                        <q-icon :name="getResult" :color="getResultColor" size="1.5rem" v-if="trail.user_trail_progress == 100 || trail.trail_user_result_status == 2" />
                    </vc-donut>
                </div>

                <div class="col-12">
                    <div class="row gutter-sm">
                        <div class="col-6">
                            <p class="caption" v-if="trail.areas.length > 0">
                                {{ $t('areas') }}
                            </p>
                            <p v-if="trail.areas.length > 0" class="tooltip q-mb-sm">
                                <span v-for="(area, index) in trail.areas" :key="index">
                                    {{ getArea(area) }}<span v-if="(trail.areas.length - 1) > index">, </span>
                                </span>
                            </p>

                            <p class="caption" v-if="trail.user_groups.length > 0">
                                {{ $t('groups') }}
                            </p>
                            <p v-if="trail.user_groups.length > 0" class="tooltip q-mb-sm">
                                <span v-for="(group, index) in trail.user_groups" :key="index">
                                    {{ getGroup(group) }}<span v-if="(trail.user_groups.length - 1) > index">, </span>
                                </span>
                            </p>
                        </div>

                        <div class="col-6">
                            <p class="caption" v-if="trail.tags.length > 0">
                                {{ $t('tags') }}
                            </p>
                            <p class="tooltip q-mb-sm">
                                <span v-for="(tag, index) in trail.tags" :key="index">
                                    {{ getTag(tag) }}<span v-if="(trail.tags.length - 1) > index">, </span>
                                </span>
                            </p>
                        </div>

                        <div class="col-12 q-mt-md" v-if="trail.is_blocked && trail.trail_parent_title">
                            <p class="caption">
                                {{ $t('requirements') }}
                            </p>
                            <p class="tooltip">
                                {{ trail.trail_parent_title }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </q-card-main>

        <q-card-separator />

        <q-card-actions v-if="actions.length > 0">
            <p class="text-center fit">
                <q-btn flat v-for="(action, index) in actions" :key="index" :icon="action.icon" color="primary" :label="getLabel(action.label)" :color="getColor(action.slug)" @click="doAction(action.slug)">
                    <q-tooltip v-if="action.tooltip">
                        {{ $t(action.tooltip) }}
                    </q-tooltip>
                </q-btn>
            </p>
        </q-card-actions>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { colors } from 'quasar'

export default {
    props: ['trail'],

    data() {
        return {
            selected_client_params: [],
            sections: [],
            is_collapsed: false,
        }
    },

    computed: {
        ...mapGetters({
            all_tags: 'site_lists/tags',
            all_areas: 'site_lists/country_areas',
            group_users: 'site_lists/group_users_labels',
            clients: 'params/clients',
            params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getResult() {
            if (this.trail.trail_user_result_status == 1) {
                return 'fal fa-trophy'
            }
            else if (this.trail.trail_user_result_status == 2) {
                return 'fal fa-ban'
            }
        },

        getPlaceholder() {
            if (!this.selected_client_params.group_training_placeholder) return ''
            else return this.selected_client_params.group_training_placeholder
        },

        getResultColor() {
            if (this.trail.trail_user_result_status == 1) {
                return 'positive'
            }
            else if (this.trail.trail_user_result_status == 2) {
                return 'negative'
            }
        },

        actions() {
            let actions = []
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) {
                actions.push({
                    icon: 'fal fa-pen',
                    label: 'qty_published_group_trainings',
                    tooltip: 'training_quantity',
                    slug: 'training_quantity'
                })
                actions.push({
                    icon: 'fal fa-graduation-cap',
                    label: 'qty_user_group_trainings_results',
                    tooltip: 'training_quantity_finished',
                    slug: 'training_quantity_finished'
                })
                actions.push({
                    icon: 'fal fa-thumbs-up',
                    label: 'likes',
                    tooltip: 'likes',
                    slug: 'likes'
                })
                if(obj.use_comments_trail) {
                    actions.push({
                        icon: 'fal fa-star',
                        label: 'stars',
                        tooltip: 'add_comment',
                        slug: 'stars'
                    })
                }
                actions.push({
                    icon: 'fal fa-heart',
                    label: 'favorite',
                    tooltip: 'add_favorite',
                    slug: 'favorite'
                })
            }
            return actions
        }
    },

    methods: {
        goToTrail() {
            if (!this.trail.is_blocked) this.$router.push({ name: 'trail', params: { id: this.trail.id } })
        },

        getArea(id) {
            let obj = this.all_areas.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getGroup(id) {
            let obj = this.group_users.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getTag(id) {
            let obj = this.all_tags.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        },

        getDonutColor(percentage) {
            if (percentage > 0 && percentage <= 24) {
                return '#DB2828'
            }
            else if (percentage >= 25 && percentage <= 74) {
                return '#F2C037'
            }
            else if(percentage >= 75) {
                return '#21BA45'
            }
        },

        getPercentage(percentage) {
            if (!percentage) {
                return 0
            }
            else if (percentage < 100) {
                return parseInt(percentage)
            }
        },

        getColor(slug) {
            if (slug == 'likes') {
                if (this.trail.liked) return 'secondary'
                else return ''
            }
            else if (slug == 'stars') {
                if (this.trail.starred) return 'secondary'
                else return ''
            }
            else if (slug == 'favorite') {
                if (this.trail.favorited) return 'negative'
                else return ''
            }
            else {
                return ''
            }
        },

        doAction(slug) {
            if (slug == 'likes') {
                this.$emit('clickLike', this.trail.id)
            }
            else if (slug == 'stars') {
                this.$emit('clickStars', this.trail.id)
            }
            else if (slug == 'favorite') {
                this.$emit('clickFavorite', this.trail.id)
            }
        },

        getLabel(label) {
            switch(label) {
                case 'qty_published_group_trainings': return this.trail.qty_published_group_trainings
                break
                case 'qty_tests': return this.trail.qty_user_group_trainings_results
                break
                case 'likes': return this.trail.likes
                break
                case 'stars': return `${this.trail.stars} / 5`
                break
            }
        }
    },

	created() {
        this.sections = []

        if (this.trail.trail_user_result_status != 2) {
            this.sections.push({
                value: this.trail.user_trail_progress ? this.trail.user_trail_progress > 100 ? 100 : this.trail.user_trail_progress : 0,
                color: this.getDonutColor(this.trail.user_trail_progress)
            })
        }
        else {
            this.sections.push({
                value: 100,
                color: '#DB2828'
            })
        }

        this.selected_client_params = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
	}
}
</script>

<style lang="stylus" scoped>
.line-card
    border-top: 3px solid transparent
    border-top-left-radius inherit
    border-top-right-radius inherit

p
    margin 0 0 5px

.training-thumb
    width 90%
    height auto
    border-radius 10px
</style>
